import { connect } from 'react-redux';

import { selectors } from 'dux/createInstance';
import Price from './Price';

function mapStateToProps(state) {
  return { ...selectors.getCreateInstanceState(state) };
}

export default connect(mapStateToProps, null)(Price);
